import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://coupon.ioyou.co.jp';

const forceTLS = process.env.REACT_APP_REVERB_SCHEME === 'https';
const wsPort =
  parseInt(process.env.REACT_APP_REVERB_PORT, 10) || (forceTLS ? 443 : 80);
const enabledTransports = (process.env.REACT_APP_REVERB_TRANSPORTS || 'ws')
  .split(',')
  .map((t) => t.trim())
  .filter(Boolean);

const echo = new Echo({
  broadcaster: 'reverb',
  key: process.env.REACT_APP_REVERB_APP_KEY,
  wsHost: process.env.REACT_APP_REVERB_HOST,
  wsPort,
  forceTLS,
  enabledTransports,
  authorizer: (channel) => ({
    authorize: (socketId, callback) => {
      const token = localStorage.getItem('token');
      fetch(`${API_BASE_URL}/api/broadcasting/auth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          socket_id: socketId,
          channel_name: channel.name,
        }),
      })
        .then((res) => {
          if (!res.ok) throw new Error(`Auth failed: ${res.status}`);
          return res.json();
        })
        .then((data) => callback(null, data))
        .catch((error) => callback(error));
    },
  }),
});

window.Echo = echo;

export default echo;
